<div inject-icons style="display: none"></div>

<div class="staging-banner" *ngIf="isStaging">Version staging!</div>

<t-dialogs></t-dialogs>

<t-alerts></t-alerts>

<t-main-menu></t-main-menu>

<t-breadcrumb></t-breadcrumb>

<router-outlet></router-outlet>